import {
  type CommonComponentProps,
  useCreateComponent,
  useUpdateWithSetter,
} from '@stripe/react-connect-js'

// shortcut: @stripe/react-connect-js 3.5.0 knows these tags but exports no React wrappers;
// switch to its ConnectTerminalHardwareShop/Orders once a stable release exports them.
function useTerminalHardwareComponent(
  tagName: 'terminal-hardware-shop' | 'terminal-hardware-orders',
  { onLoadError, onLoaderStart }: CommonComponentProps
) {
  const { wrapper, component } = useCreateComponent(tagName)
  useUpdateWithSetter(component, onLoaderStart, (comp, value) => comp.setOnLoaderStart(value))
  useUpdateWithSetter(component, onLoadError, (comp, value) => comp.setOnLoadError(value))
  return wrapper
}

export function ConnectTerminalHardwareShop(props: CommonComponentProps) {
  return useTerminalHardwareComponent('terminal-hardware-shop', props)
}

export function ConnectTerminalHardwareOrders(props: CommonComponentProps) {
  return useTerminalHardwareComponent('terminal-hardware-orders', props)
}
